module.exports = __webpack_public_path__ + "static/img/weather_thunder.c85f48c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather_thunder.png
// module id = uwri
// module chunks = 2